import { size, slice } from 'lodash';

import useToggler from './useToggler';

interface Input<T> {
    initSize: number;
    items: T[];
}

interface Output<T> {
    hasToggleMore: boolean;
    moreCount: number;
    visibleItems: T[];
    toggleShowMore: VoidFunction;
}

const useMore = <T extends JSX.Element>({
    initSize,
    items,
}: Input<T>): Output<T> => {
    const allSize = size(items);
    const hasToggle = allSize > initSize;

    const [isShowMore, toggleShowMore] = useToggler(false);

    const visibleItems = isShowMore ? items : slice(items, 0, initSize);
    const moreCount = allSize - size(visibleItems);

    return {
        hasToggleMore: hasToggle,
        moreCount,
        visibleItems,
        toggleShowMore,
    };
};

export default useMore;
